<div class="d-flex flex-row align-items-center status-light" [ngClass]="bgClass">
    <div class="mr-1">
        <div [ngClass]="statusClass"></div>    
    </div>
    <div class="text-grey">
        {{ status }}
    </div>
  </div>